import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersRoleplayingConditionTemplateIndexRequestType,
  ApiManagersRoleplayingConditionTemplateIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersRoleplayingConditionTemplateIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersRoleplayingConditionTemplateIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersRoleplayingConditionTemplateIndexResponseType>(
      "/api/managers/roleplaying_condition_templates",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersRoleplayingConditionTemplateIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersRoleplayingConditionTemplatesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersRoleplayingConditionTemplateIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersRoleplayingConditionTemplatesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
